var _rect, _circle, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo01Machinery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#8DBA23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 499.5,
    cy: 499.5,
    r: 411.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 723.422,
    y: 45.2305,
    width: 311.533,
    height: 386.677,
    rx: 42,
    transform: "rotate(45 723.422 45.2305)",
    fill: "#8DBA23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01Machinery);
export default __webpack_public_path__ + "static/media/logo01machinery.096d9375c55d5285b93d3a88898b26ed.svg";
export { ForwardRef as ReactComponent };